// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
  brandName: "Chaitanya Model Techno School",
    contact: "+91 7760729199,9448649199 | tnrlgs78@gmail.com",
    socialLinks: {
      instagram: "https://www.instagram.com/",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com",
      facebook:   "https://www.facebook.com/p/Chaitanya-Model-Techno-School-100070959335251/",
      twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
